import type { ExtractFnReturnType } from "apps/visits/core/lib/react-query";
import type { AxiosError } from "axios";
import { type UseQueryOptions, useQuery } from "react-query";
import { VouchersDistributionsRepository } from "./vouchers-distribution.api";
import type { BasicDTO } from "./vouchers-distribution.types";

const vouchersDistributionsRepository = new VouchersDistributionsRepository();

type QueryFnType = typeof vouchersDistributionsRepository.getPackages;
type ApiData = ExtractFnReturnType<QueryFnType>;

type UseGetPackagesOptions = {
  config?: UseQueryOptions<ApiData, AxiosError>;
} & BasicDTO;

export const useGetPackages = ({ config, ...rest }: UseGetPackagesOptions) => {
  return useQuery<ApiData, AxiosError>({
    queryKey: ["packages", rest.configName],
    queryFn: () => vouchersDistributionsRepository.getPackages(rest),
    ...config,
  });
};
